import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import 'datejs';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DATE_PICKER_FORMAT } from './constants';
import { languageSelector } from '../../../store/selectors/appSelectors';
import { getDateFromNativeDateObject } from '../../../utils/dateUtils';
// import { DatePicker } from '@hid-galaxy-ui/galaxy-react';
import DatePicker from '../../DatePicker'
import './RpldatePicker.scss'
import {
  addYears,

} from "date-fns";

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
  },
}));

const InputDatePicker = ({
  notearlierthan,
  errormessagenotearlierthan,
  notlaterthan,
  errormessagenotlaterthan,
  hint,
  label,
  format,
  max,
  className,
  minDate = addYears(new Date(), -100),
  required=false,
  ...props
}) => {
  const language = useSelector(languageSelector);
  const { t } = useTranslation();
  const classes = useInputStyles();
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const {
    field: { name, value },
  } = props;

  const {
    form: { errors, setFieldValue, touched },
  } = props;

  const [isAfterMount, setIsAfterMount] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (!value) {
      setFieldValue(name, null);
      return;
    }

    if (value) {
      setSelectedValue(new Date(value));
    }

    // To prevent validate whole form when form mount
    if (!isAfterMount) {
      setIsAfterMount(true);
      return;
    }

    const formatedDate = getDateFromNativeDateObject(value); // new Date(value).toString('yyyy-MM-dd');

    setFieldValue(name, formatedDate);
  }, [value, name, setFieldValue, isAfterMount]);
  // const maxDateDefault = '2100-01-01';
  // const minDateDefault = '1900-01-01';

  const getHelperText = () => (touched[name] && errors[name] ? errors[name] : hint);

  const onDateChange = (selectedDate) => {
    const formatedDate = selectedDate ? getDateFromNativeDateObject(selectedDate) : null; // new Date(value).toString('yyyy-MM-dd');
    setSelectedValue(selectedDate);
    setFieldValue(name, formatedDate);
  };
  return (
    <div className={className}>
      <DatePicker
        onChange={(val) => onDateChange(val)}
        format={format ?? DEFAULT_DATE_PICKER_FORMAT}
        isError={!!getHelperText()}
        id={name}
        name={name}
        label={label}
        value={selectedValue}
        helperText={getHelperText()}
        maxDate={max}
        minDate={minDate}
        isClearable
        isRequired={required}
                showYearMonthDropdown={true}

      />
    </div>
  );
};

InputDatePicker.propTypes = {
  // hint: PropTypes.string,
  label: PropTypes.string.isRequired,
  // notearlierthan: PropTypes.string.isRequired,
  // errormessagenotearlierthan: PropTypes.string.isRequired,
  // notlaterthan: PropTypes.string.isRequired,
  // errormessagenotlaterthan: PropTypes.string.isRequired,
};

InputDatePicker.defaultProps = {
  hint: null,
};

export default InputDatePicker;
